import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from 'pages/login/login';
import Layout from 'components/layout/layout';

import MORoute from 'pages/monitor-overview/route';
import MODataOverview from 'pages/monitor-overview/data-overview/data-overview';
import MOWarningOverview from 'pages/monitor-overview/warning-overview/warning-overview'; // 监管总览-预警总览
import MOEnterpriseDetail from 'pages/monitor-overview/warning-overview/enterprise-detail'; // 监管总览-预警总览企业详情
import MOHistoryDetail from 'pages/monitor-overview/warning-overview/history-detail'; // 监管总览-预警总览历史详情

import RWRoute from 'pages/risk-warning/route';
import RWProductionWarning from 'pages/risk-warning/production-warning/warning-type'; // 风险预警-生产预警
import RWCirculateWarning from 'pages/risk-warning/circulate-warning/warning-type'; // 风险预警-流通预警
import RWDataMonitor from 'pages/risk-warning/data-monitor/data-monitor'; // 风险预警-数据监控
import RWComplaintMonitor from 'pages/risk-warning/complaint-monitor/complaint-monitor'; // 风险预警-投诉监管
import RWSentimentMonitor from 'pages/risk-warning/sentiment-monitor/sentiment-monitor'; // 风险预警-舆情监管
import WaringList from 'pages/risk-warning/warning/warning-list'; // 预警列表

import PERoute from 'pages/production-enterprise/route'; // 生产监管
import PEInfo from 'pages/production-enterprise/enterprise-info/info'; // 生产企业概况
// import PEAreaDetail from 'pages/production-enterprise/enterprise-info/area-detail'; // 某地区生产企业统计
import PEDrugInfo from 'pages/production-enterprise/enterprise-info/drug-info'; // 某地区生产企业统计
import PEScale from 'pages/production-enterprise/enterprise-info/scale'; // 生产企业规模
import PEMonitorList from 'pages/production-enterprise/monitor/list'; // 生产数据监管列表
import PEMonitorDetail from 'pages/production-enterprise/monitor/detail'; // 生产数据监管
import PEDrugStockDetail from 'components/monitor-dimension/drug-stock-detail'; // 生产数据监管-药品入库-echarts详情

import CERoute from 'pages/circulate-enterprise/route'; // 流通监管
import CEEnterPriseInfo from 'pages/circulate-enterprise/enterprise-info/enterprise-info'; // 企业概况
import CECirculateInfo from 'pages/circulate-enterprise/circulate-info/circulate-info'; // 流通概况
import CECirculateMonitor from 'pages/circulate-enterprise/circulate-monitor/monitor-list'; // 流通数据监管
import CECirculateMonitorDetail from 'pages/circulate-enterprise/circulate-monitor/monitor-detail'; // 流通数据监管
import CEDetail from 'components/monitor-dimension/environment-detail'; // 环境数据详情

import SystemAdmin from 'pages/system-admin/route'; // 系统管理
import OrganAdmin from 'pages/system-admin/organ-admin';
import UserAdmin from 'pages/system-admin/user-admin';
import MenuAdmin from 'pages/system-admin/menu-admin';
import RoleAdmin from 'pages/system-admin/role-admin';
import SentimentAdmin from 'pages/system-admin/sentiment-admin';
import EnterPriseVideoAdmin from 'pages/system-admin/enterprise-video-admin';
import ClientEditionAdmin from 'pages/system-admin/client-edition-admin';

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '',
      redirect: '/login'
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/page',
      component: Layout,
      children: [
        {
          path: 'monitorOverview',
          component: MORoute,
          children: [
            {
              path: 'dataOverview',
              component: MODataOverview
            },
            {
              path: 'warningOverview',
              component: MOWarningOverview
            },
            {
              path: 'enterpriseDetail/:enterpriseName',
              component: MOEnterpriseDetail
            },
            {
              path: 'historyDetail',
              component: MOHistoryDetail
            }
          ]
        },
        {
          path: 'riskWarning', // 风险预警
          component: RWRoute,
          children: [
            {
              path: 'productionWarning',
              component: RWProductionWarning
            },
            {
              path: 'circulateWarning',
              component: RWCirculateWarning
            },
            {
              path: 'dataMonitor',
              component: RWDataMonitor
            },
            {
              path: 'complaintMonitor',
              component: RWComplaintMonitor
            },
            {
              path: 'sentimentMonitor',
              component: RWSentimentMonitor
            },
            {
              path: 'waringList/:waringBigType/:waringSmallType',
              component: WaringList
            }
          ]
        },
        {
          path: 'productingEnterprise', // 生产监管
          component: PERoute,
          children: [
            {
              path: 'info',
              component: PEInfo
            },
            // {
            //   path: 'areaDetail/:areaCode/:cityName',
            //   component: PEAreaDetail
            // },
            {
              path: 'drugInfo/:cityCode',
              component: PEDrugInfo
            },
            {
              path: 'scale/:level',
              component: PEScale
            },
            {
              path: 'monitorList',
              component: PEMonitorList
            },
            {
              path: 'monitorDetail/:type',
              component: PEMonitorDetail
            },
            {
              path: 'drugStockDetail',
              component: PEDrugStockDetail
            }
          ]
        },
        {
          path: 'circulateEnterprise', // 流通监管
          component: CERoute,
          children: [
            {
              path: 'enterpriseInfo',
              component: CEEnterPriseInfo
            },
            {
              path: 'circulateInfo',
              component: CECirculateInfo
            },
            {
              path: 'circulateMonitor',
              component: CECirculateMonitor
            },
            {
              path: 'environmentDetail',
              component: CEDetail
            },
            {
              path: 'circulateMonitorDetail/:type',
              component: CECirculateMonitorDetail
            }
          ]
        },
        {
          path: 'systemAdmin', // 系统管理
          component: SystemAdmin,
          children: [
            {
              path: 'organAdmin',
              component: OrganAdmin
            },
            {
              path: 'userAdmin',
              component: UserAdmin
            },
            {
              path: 'menuAdmin',
              component: MenuAdmin
            },
            {
              path: 'roleAdmin',
              component: RoleAdmin
            },
            {
              path: 'sentimentAdmin',
              component: SentimentAdmin
            },
            {
              path: 'enterpriseVideoAdmin',
              component: EnterPriseVideoAdmin
            },
            {
              path: 'clientEditionAdmin',
              component: ClientEditionAdmin
            }
          ]
        }
      ]
    }
  ]
});
